<script>

  import {mapActions, mapGetters} from 'vuex';

  import moduleUtils from '../ModuleUtils';

  import ModuleList from './ModuleList.vue'
  import ModuleForm from './ModuleForm.vue'
  import ModuleShow from './ModuleShow.vue'
  import ModuleCustom from './ModuleCustom.vue'
  import ModuleDashboard from './ModuleDashboard.vue'
  import ModuleFree from './ModuleFree.vue'
  import ModuleReport from './ModuleReport.vue'

  export default {
    name: 'sgs-module-wrapper',
    props: [
      'businessAreaId',
      'systemId',
      'systemVersion',
      'formId',
      'parentId'
    ],
    data: function() {
      return {
        form: {},
        moduleType: '',
        moduleActive: 'list',
        moduleActiveDataId: '',
        moduleChild: [],
        moduleFilter: [],
        createView: true,
        deleteButton: true,
        editView: true,
        showView: true,
        customTemplate: '',
        showDialogWithForm: false,
        formIdModal: '',
        parentIdModal: ''
      }
    },
    computed: {
      ...mapGetters([
        'userLoggedRoles'
      ]),
      title: function() {
        if (this.form) {

          let title = this.form.labelPt;

          if (this.$i18n.locale == 'es' && this.form.labelEs) {
            title = this.form.labelEs;
          } else if (this.$i18n.locale == 'en' && this.form.labelEn) {
            title = this.form.labelEn;
          }

          return title;
        }
      },
      _moduleChild: function() {
        return _.sortBy(this.moduleChild, ['labelPt']);
      }
    },
    mounted () {
      this.resolveModuleDescription();
    },
    components: {
      ModuleList, ModuleForm,
      ModuleShow, ModuleCustom,
      ModuleDashboard, ModuleReport,
      ModuleFree
    },
    watch: {
      'formId': function() {
        this.resolveModuleDescription();
      }
    },
    methods: {
      ...mapActions([
        'userHasRole'
      ]),
      formIdentifier: function() {
        return {
          businessAreaId: this.businessAreaId,
          systemId:  this.systemId,
          systemVersion: this.systemVersion,
          formId: this.formId
        };
      },
      resolveModuleDescription: function() {

        this.moduleType = ''
        this.moduleActive = 'list'
        this.moduleActiveDataId = ''
        this.moduleChild = []
        this.moduleFilter = []
        this.createView = true
        this.deleteButton = true
        this.editView = true
        this.showView = true
        this.customTemplate = ''

        moduleUtils.resolveModuleDescription(this.formIdentifier()).then(response => {

          this.form = response;

          if (this.form) {

            this.moduleType = this.form.type;

            if (this.form.type == 'CRUD') {
              if (this.form.fieldDesc) {
                this.form.children.map(it => {
                  if (it.availableInWeb) {
                    this.userHasRole(it.id).then((response) => {
                      if (response) {
                        this.moduleChild.push(it);
                      }
                    });
                  }
                });

                this.moduleFilter = this.form.fieldDesc.filter;
                this.createView = this.form.createView;
                this.deleteButton = this.form.deleteButton;
                this.editView = this.form.editView;
                this.showView = this.form.showView;
              }

            } else if (this.moduleType == 'CUSTOM') {
              this.customTemplate = this.form.customTemplate;
            }
          }

        })
      },
      changeModuleActive: function(moduleName, id) {
        this.moduleActive = moduleName;
        this.moduleActiveDataId = id;
      },
      rows: function() {
        if (this.form && this.form.fieldDesc) {
          return this.form.fieldDesc.rows;
        }
        return [];
      },
      fields: function() {
        if (this.form && this.form.fieldDesc && (Object.keys(this.form.fieldDesc).length > 0)) {
          return this.form.fieldDesc.fields;
        }
        return [];
      },
      filter: function() {
        if (this.form && this.form.fieldDesc && this.form.fieldDesc.filter) {
          return this.form.fieldDesc.filter;
        }
        return [];
      },
      children: function() {
        if (this.form && this.form.fieldDesc) {
          return this.form.children;
        }
        return [];
      },
      parentColumnName: function() {
        if (this.form && this.form.parentColumnName) {
          return this.form.parentColumnName;
        }
        return '';
      },
      showChildrenTabs: function() {
        return this.children().length > 0;
      },
      actionLinkSelected: function (formId, dataRow) {

        /*
        this.$router.push({
          name: 'ModuleList',
          params: {
            formId: formId
          }
        });
        */

        this.showDialogWithForm = true;
        this.formIdModal = formId;
        this.parentIdModal = dataRow.id;
      },
      childTitle: function(child) {

        let title = child.labelPt;

        if (this.$i18n.locale == 'es' && child.labelEs) {
          title = child.labelEs;
        } else if (this.$i18n.locale == 'en' && child.labelEn) {
          title = child.labelEn;
        }

        return title;
      }
    }
  }
</script>

<template>
  <div id="moduleWrapper">

    <template v-if="moduleType == 'CRUD'">

      <module-list v-if="moduleActive == 'list'" @changeModuleActive="changeModuleActive"
                 :fields="fields()"
                 :formIdentifier="formIdentifier()"
                 :parentId="parentId"
                 :parentColumnName="parentColumnName()"
                 :title="title"
                 :filter="moduleFilter"
                 :showCreateButton="createView"
                 :showEditIcon="editView"
                 :showShowIcon="showView"
                 @actionLinkSelected="actionLinkSelected"
                 :businessRulesBeforeCrudViewList="form.businessRulesBeforeCrudViewListId"
      />

      <module-form v-if="moduleActive == 'form'" @changeModuleActive="changeModuleActive"
                   :rows="rows()"
                   :fields="fields()"
                   :formIdentifier="formIdentifier()"
                   :id="moduleActiveDataId"
                   :parentId="parentId"
                   :parentColumnName="parentColumnName()"
                   :title="title"
                   @actionLinkSelected="actionLinkSelected"
                   :businessRulesBeforeCrudViewCreate="form.businessRulesBeforeCrudViewCreateId"
                   :businessRulesBeforeCrudViewEdit="form.businessRulesBeforeCrudViewEditId"
      />

      <module-show v-if="moduleActive == 'show'" @changeModuleActive="changeModuleActive"
                   :rows="rows()"
                   :fields="fields()"
                   :formIdentifier="formIdentifier()"
                   :id="moduleActiveDataId"
                   :parentId="parentId"
                   :parentColumnName="parentColumnName()"
                   :title="title"
                   :showEditButton="editView"
                   :showDeleteButton="deleteButton"
                   :showCreateButton="createView"
                   @actionLinkSelected="actionLinkSelected"
                   :businessRulesBeforeCrudViewShow="form.businessRulesBeforeCrudViewShowId"
      />
      <template v-if="moduleActive == 'show'">
        <div class="panel" v-if="moduleChild.length">
          <div class="panel-body">
            <el-tabs>

              <el-tab-pane v-for="child in _moduleChild" :label="childTitle(child)">
                <sgs-module-wrapper
                  :businessAreaId="formIdentifier().businessAreaId"
                  :systemId="formIdentifier().systemId"
                  :systemVersion="formIdentifier().systemVersion"
                  :formId="child.id"
                  :parentId="moduleActiveDataId"
                />
              </el-tab-pane>

            </el-tabs>
          </div>
        </div>
      </template>

    </template>

    <template v-if="moduleType == 'CUSTOM'">

      <module-custom
        :title="title"
        :formIdentifier="formIdentifier()"
        :customTemplate="customTemplate"
        :parentId="parentId"
        @actionLinkSelected="actionLinkSelected"
      >
      </module-custom>

    </template>

    <template v-if="moduleType == 'DASHBOARD'">

      <module-dashboard
        :rows="rows()"
        :fields="fields()"
        :formIdentifier="formIdentifier()"
        :parentId="parentId"
        :title="title"
        @actionLinkSelected="actionLinkSelected"
        :businessRulesBeforeOtherView="form.businessRulesBeforeOtherViewId"
      />

    </template>

    <template v-if="moduleType == 'REPORT'">
      <module-report
        :rows="rows()"
        :fields="fields()"
        :formIdentifier="formIdentifier()"
        :parentId="parentId"
        :title="title"
        @actionLinkSelected="actionLinkSelected"
        :businessRulesBeforeOtherView="form.businessRulesBeforeOtherViewId"
      />

    </template>

    <template v-if="moduleType == 'FREE'">

      <module-free
        :rows="rows()"
        :fields="fields()"
        :formIdentifier="formIdentifier()"
        :parentId="parentId"
        :title="title"
        @actionLinkSelected="actionLinkSelected"
        :businessRulesBeforeOtherView="form.businessRulesBeforeOtherViewId"
      />

    </template>

    <el-dialog :visible.sync="showDialogWithForm" v-if="showDialogWithForm" size="large" id="modal">
      <module-template>
        <sgs-module-wrapper
          :businessAreaId="formIdentifier().businessAreaId"
          :systemId="formIdentifier().systemId"
          :systemVersion="formIdentifier().systemVersion"
          :formId="formIdModal"
          :parentId="parentIdModal"
        />
      </module-template>
    </el-dialog>

  </div>
</template>



// WEBPACK FOOTER //
// ModuleWrapper.vue?ac1b3fb4